<button nbButton size="small" [nbPopover]="uiLangOptions" type="button" ghost>
  <nb-icon icon="globe" class="text-basic-100" />
  <span class="text-basic-100">{{ uiCurrentLang$ | async | uppercase }}</span>
</button>

<ng-template #uiLangOptions>
  @if (uiCurrentLang$ | async; as currentLang) {
  <nb-list>
    @for (lang of uiAvailableLanguages | keyvalue; track lang) {
    <nb-list-item
      [ngClass]="{ 'is-active': lang.value.code2 === currentLang }"
      (click)="lang.value.code2 === currentLang ? null : changeLang(lang.key)"
      class="uppercase text-sm">
      <span>{{ lang.value.code2 | uppercase }}</span>
    </nb-list-item>
    }
  </nb-list>
  }
</ng-template>
